<template>
  <b-container fluid>
    <div class="iq-card mt-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title py-2">
          <h4 class="card-title">Config Rpm List</h4>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right">
              <button-options
                :access="'master_config_rpm'"
                :hideAdd="false"
                :hideDetail="true"
                :isRefreshEnabled="true"
                :isRefreshed="isRefreshed"
                @onAddItemClicked="openAddForm"
                @onRefreshed="getData('Refreshed')"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="iq-card-body">
        <b-row class="mb-3">
          <b-col md="4">
            <label>Filter Device ID:</label>
            <b-input-group>
              <b-form-input
                v-model="filter.mcrpDevcId"
                type="number"
                placeholder="Device ID"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary" @click="clearFilter">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <config-rpm-list
              :access="'master_config_rpm'"
              :data="data"
              :loading="isLoading"
              :pagination="pagination"
              @onActionDelete="openDelete"
              @onActionEdit="openEdit"
              @onActionView="openDetail"
              @onPageChanged="onPageChanged"
              @update="onUpdated"/>
          </b-col>
        </b-row>
      </div>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayForm">
        <config-rpm-form
          :data="currentConfigRpm"
          :errors="errors"
          :isSubmit="isSubmit"
          @onSubmitClicked="onSubmitClicked"
          @onCancelAddClicked="onCancel" />
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        v-model="displayDeletion">
        <delete-item
          :isSubmit="isSubmit"
          @onCancelDeletion="displayDeletion = false"
          @onConfirmDeletion="onConfirmDeletion"/>
      </b-modal>
    </div>
  </b-container>
</template>

<script>

import ButtonOptions from '@/components/directives/button-options';
import DeleteItem from '@/components/directives/delete-item';
import ConfigRpmForm from '@/components/config/rpm/Form';
import ConfigRpmList from '@/components/config/rpm/List';
import ConfigRpmSvc from '@/services/ConfigRpmSvc';

import requestBuilder from '@/util/request.builder';

export default {
  name: 'MasterConfigRpm',
  components: {
    DeleteItem,
    ConfigRpmForm,
    ConfigRpmList,
    ButtonOptions,
  },
  data() {
    return {
      currentConfigRpm: {},
      data: [],
      displayDeletion: false,
      displayForm: false,
      errors: {},
      filter: {
        mcrpDevcId: null,
      },
      isLoading: false,
      isRefreshed: false,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 50,
        totalSize: 0,
      },
    };
  },
  methods: {
    clearFilter() {
      this.filter.mcrpDevcId = null;
    },
    async deleteData(notification, data) {
      this.isSubmit = true;
      try {
        const resp = await ConfigRpmSvc.deleteConfigRPM(data.mcrpId);
        if (resp.status.error === 0) {
          this.$toast.success(notification);
          this.displayDeletion = false;
          this.pagination.current = 1;
          this.getData();
        } else {
          this.$toast.error(resp.status.message);
        }
      } catch (e) {
        this.$toast.error(e.message);
      } finally {
        this.isSubmit = false;
      }
    },
    async getData(notification) {
      this.isLoading = true;
      this.isRefreshed = true;
      try {
        const resp = await ConfigRpmSvc.getConfigRPM({
          ...requestBuilder.buildFilters(this.pagination, this.filter),
        });
        this.data = resp.data;
        this.pagination.totalSize = resp.pagination.totalData;

        if (notification) {
          this.$toast.success(notification);
        }
      } catch (e) {
        console.error('getData error', e);
        this.$toast.error('Something Wrong When Fetching Data');
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    onCancel() {
      this.currentConfigRpm = {};
      this.displayForm = false;
    },
    onConfirmDeletion() {
      this.deleteData('Deleted complete', this.selected);
    },
    onPageChanged(page) {
      this.pagination.current = page;
      this.getData();
    },
    onUpdated() {
      this.getData('Updated');
    },
    async onSubmitClicked(form) {
      this.errors = {};
      this.isSubmit = true;
      try {
        let resp = {};
        if (form.mcrpId) {
          const mcrpId = form?.mcrpId;

          delete form?.mcrpId;
          delete form?.mcrpUpdatedUserId;
          delete form?.mcrpCreatedUserId;
          delete form?.mcrpCreatedTime;
          delete form?.mcrpUpdatedTime;
          delete form?.mcrpDevc;

          resp = await ConfigRpmSvc.updateConfigRPM(mcrpId, form);
        } else {
          resp = await ConfigRpmSvc.createConfigRPM(form);
        }
        if (resp.status.error === 0) {
          await this.getData('Success');
          this.currentConfigRpm = {};
          this.displayForm = false;
        } else {
          const errors = resp.status.message;
          if (typeof errors === 'object') {
            this.errors = resp.status.message;
            this.$toast.error('Error found');
          } else {
            this.$toast.error(resp.status.message);
          }
        }
      } catch (e) {
        console.error('error submit data : ', e);
        this.$toast.error('failed to submit data');
      } finally {
        this.isSubmit = false;
      }
    },
    openAddForm() {
      this.currentConfigRpm = {};
      this.displayForm = true;
    },
    openDelete(data) {
      this.displayDeletion = true;
      this.selected = data;
    },
    openDetail(data) {
      this.$router.push({ name: 'RoleDetail', params: { id: data.mcrpId } });
    },
    openEdit(data) {
      this.displayForm = true;
      this.currentConfigRpm = { ...this._.find(this.data, (v) => v.mcrpId === data.mcrpId) };
    },
    doLogOut() {
      this.$toast.error('Please re-login');
      this.$store.dispatch('auth/logout');
      this.$router.replace({ name: 'Login' });
    },
  },
  watch: {
    'filter.mcrpDevcId': {
      handler() {
        this.pagination.current = 1;
        this.getData();
      },
    },
  },
  mounted() {
    const { devcId } = this.$route.query;
    if (devcId) {
      this.filter.mcrpDevcId = Number(devcId);
      return;
    }
    this.getData();
  },
};
</script>

<style scoped>

</style>
